import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface IDeliveryZone {
  id: string;
  businessId: string;
  name: string;
  zoneType: string;
  bbox: { north: number; south: number; east: number; west: number } | null;
  district: string | null;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const list = async (data?: {
  filter?: { isActive?: boolean | null; zoneType?: string };
  offset?: { limit: number; skip: number };
}) =>
  httpRequest.post("/ord/delivery-zone/list", (data ?? {}) as never) as Promise<{
    rows: IDeliveryZone[];
    count: number;
  }>;

export const create = async (input: Partial<IDeliveryZone>) =>
  httpRequest.post("/ord/delivery-zone", input as never);

export const remove = async (id: string) =>
  httpRequest.del(`/ord/delivery-zone/${id}`);
